<form #paymentForm ngNoForm method="post" action="{{paymentConfigurationUrl}}">
  <input type="hidden" name="URLBACK" value="{{urlBack}}">
  <ng-container *ngFor="let data of paymentSIAConfigurationData | keyvalue">
    <input type="hidden" name="{{data.value.name}}" value="{{data.value.value}}">
  </ng-container>
  <button type="button">&nbsp;</button>
</form>
